import React from 'react';
import { useTranslation } from '@shared/core';
import type { FlexProps } from '@withjoy/joykit';
import { Flex, TextV2 } from '@withjoy/joykit';
import { ProgressRing } from '../ProgressRing';
import { StyledButton, StyledPriceRangeWrapper, StyledTextWrapper, styles } from './styles';
import type { Page } from '../../telemetry';
import { useHandlePriceRangeClick } from '../../RegistryGiftCounts.controller';

interface PriceRangeProps extends FlexProps {
  title: string;
  targetGiftCount: number;
  completedGiftCount: number;
  isOpen: boolean;
  priceRangeQuery: string;
  page: Page;
  onActionComplete?: () => void;
}

export const PriceRange = ({ title, targetGiftCount, completedGiftCount, isOpen, priceRangeQuery, onActionComplete, page, ...props }: PriceRangeProps) => {
  const { t } = useTranslation('sharedComponents');
  const { giftCounts, button } = t('registryGiftCounts');

  const { handlePriceRangeClick } = useHandlePriceRangeClick(page, onActionComplete);

  return (
    <StyledPriceRangeWrapper
      __css={styles.priceRangeWrapper}
      {...props}
    >
      <ProgressRing
        isOpen={isOpen}
        currentGiftCount={completedGiftCount}
        progressPercent={(completedGiftCount / targetGiftCount) * 100}
      />
      <StyledTextWrapper __css={styles.textWrapper}>
        <Flex alignItems="center">
          <TextV2
            typographyVariant="hed1"
            whiteSpace="nowrap"
            marginRight={2}
          >
            {title}
          </TextV2>
        </Flex>
        {targetGiftCount !== 0 && (
          <TextV2
            typographyVariant="label2"
            whiteSpace="nowrap"
            color="mono10"
          >
            {giftCounts({ targetCount: targetGiftCount })}
          </TextV2>
        )}
        <StyledButton
          {...styles.button}
          onClick={() => handlePriceRangeClick(title, priceRangeQuery)}
        >
          {button()}
        </StyledButton>
      </StyledTextWrapper>
    </StyledPriceRangeWrapper>
  );
};
